const ITEMS = [
  "Romantic Tiny House",
  "Giardino segreto tra le mura",
  "Piscina SPA riscaldata",
  "Pace e riservatezza",
  "Borgo antico di Eggi",
  "Un nido per due",
  "Cene sotto le stelle",
  "Spoleto a 6 km",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-stone-300/40 bg-[#EEF1E6] py-5">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-xl italic text-stone-700 sm:text-2xl">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-oro" />
          </span>
        ))}
      </div>
    </div>
  );
}
